export const SET_SERVICE_PRICES = '@app/platformConfig/SET_SERVICE_PRICES';
export const SET_CITY_CONFIG = '@app/platformConfig/SET_CITY_CONFIG';
